<template>
  <div>
    <p class="text-muted mb-1">
      {{ $t('Estes valores valem para todos os dias da semana, exceto nos dias que você personalizar na outra aba.') }}
    </p>

    <b-row>
      <b-col
        v-if="!hideActivation"
        md="3"
      >
        <FormulateInput
          id="delivery-config-default-enabled"
          v-model="config.defaultDeliveryEnabled"
          type="switch"
          name="defaultDeliveryEnabled"
          :label="$t('Delivery habilitado')"
        />
      </b-col>
      <b-col
        v-if="!hideActivation"
        md="3"
      >
        <FormulateInput
          id="delivery-config-active"
          v-model="config.active"
          type="switch"
          name="active"
          :label="$t('Configuração ativa')"
        />
      </b-col>
    </b-row>

    <b-row>
      <b-col md="3">
        <FormulateInput
          id="delivery-config-default-min-order"
          v-model="config.defaultMinOrderValue"
          type="text-number"
          filter="currency"
          currency="R$"
          :precision="2"
          name="defaultMinOrderValue"
          :label="$t('Valor mínimo de pedido')"
        />
      </b-col>
      <b-col md="3">
        <FormulateInput
          id="delivery-config-default-fee-per-km"
          v-model="config.defaultDeliveryFeePerKilometer"
          type="text-number"
          filter="currency"
          currency="R$"
          :precision="2"
          name="defaultDeliveryFeePerKilometer"
          :label="$t('Taxa por KM')"
          :instruction="
            $t(
              'Usada nos pedidos do ERP cobrados por quilômetro. Os pedidos com taxa única e o online usam as faixas abaixo.'
            )
          "
        />
      </b-col>
    </b-row>

    <hr>

    <h5>{{ $t('Faixas de taxa de entrega') }}</h5>
    <p class="text-muted">
      {{ $t('A taxa é definida por faixas conforme o valor do pedido. Ex.: a partir de R$ 0,00 cobra R$ 8,00; a partir de R$ 80,00 fica grátis. Dias sem faixas próprias usam estas.') }}
    </p>
    <delivery-fee-tiers
      :tiers="config.defaultTiers"
      name="defaultTiers"
      :label="$t('Faixas de taxa')"
    />

    <hr>

    <h5>{{ $t('Grupos isentos da base de cálculo') }}</h5>
    <p class="text-muted">
      {{ $t('Produtos destes grupos não entram no valor usado para escolher a faixa de taxa. Ex.: excluir "Chopes" faz um pedido de R$ 200 com R$ 150 em chope contar apenas R$ 50 para a faixa.') }}
    </p>
    <b-row>
      <b-col md="8">
        <FormulateInput
          id="delivery-config-excluded-groups"
          v-model="config.excludedGroupIds"
          type="vue-select"
          name="excludedGroupIds"
          :label="$t('Grupos excluídos da taxa')"
          :options="groupOptions"
          :multiple="true"
          :placeholder="$t('Selecione os grupos (opcional)')"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { BRow, BCol } from 'bootstrap-vue'
import DeliveryFeeTiers from './DeliveryFeeTiers.vue'

/**
 * Bloco de valores de delivery (habilitação, ativa, valor mínimo, taxa por KM) e a sub-tabela de
 * faixas de taxa — onde a taxa única da loja mora (D3, D9). É reutilizado tanto na configuração
 * BASE quanto na edição de CAMPANHAS. A vigência/prioridade NÃO mora aqui.
 *
 * `hideActivation` esconde "Delivery habilitado" e "Configuração ativa" (usado nas campanhas, onde
 * o que vale é a campanha estar ativa). Não há tipo de cobrança: a loja roda os dois modelos, as
 * faixas e a taxa por KM convivem, e o pedido do ERP escolhe qual usar.
 * Não há seletor de canal (só existe B2C, D6) nem monotonicidade (D8).
 */
export default {
  components: {
    BRow,
    BCol,
    DeliveryFeeTiers,
  },

  props: {
    // Config em edição (mesma referência do estado Vuex; mutada via v-model).
    config: {
      type: Object,
      required: true,
    },
    // Esconde os switches de habilitação/ativação (contexto de campanha).
    hideActivation: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters('pages/store/deliveryConfig', ['groupOptions']),
  },
}
</script>

<style></style>
